import { IncomingHttpHeaders } from "http";
import { LegalArea } from "./getInitialisationConfig";
import { FlowType } from "@/core/types/types";

// https:gitlab.infra.flightright.net/infrastructure/cloudflare/-/blob/master/terraform/mietrecht-claimcheck.js#L30
const CLOUDFLARE_PROXY_HEADER = "x-proxied-path";

const getLegalAreaFromRequest = (
  path: string = "",
  headers: IncomingHttpHeaders = {},
  definitionName: string | string[] | undefined
): LegalArea => {
  if (typeof definitionName === "string" && definitionName === FlowType.MIE) {
    return LegalArea.MIE;
  } else if (
    typeof definitionName === "string" &&
    definitionName === FlowType.ARB
  ) {
    return LegalArea.ARB;
  }

  if (
    path.includes("/mietrecht") || // Local development
    headers[CLOUDFLARE_PROXY_HEADER]?.includes("mietrecht") // Cloudflare worker
  ) {
    return LegalArea.MIE;
  } else if (
    path.includes("/arbeitsrecht") || // Local development
    headers[CLOUDFLARE_PROXY_HEADER]?.includes("arbeitsrecht") // Cloudflare worker
  ) {
    return LegalArea.ARB;
  }

  return LegalArea.DEFAULT;
};

export default getLegalAreaFromRequest;
